import { IPaginationResponse } from '../../../common';
import { IPaymentLookupsResponse, IPaymentResponse } from '../dtos/responses';

const paymentsResponse: IPaginationResponse<IPaymentResponse> = {
  items: [
    {
      id: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      paymentRequest: {
        id: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
        paymentId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
        paymentConfigurationId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
        paymentProviderType: 'hyperpay',
        paymentRequestId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
        paymentUrl: 'url',
        integrity: 'integrity url',
        modifiedOnUtc: '2025-02-18T20:11:49.4609172',
        createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
        modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
        createdOnUtc: '2025-02-18T20:11:49.4609054'
      },
      onlinePaymentDetail: {
        id: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
        paymentId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
        paymentBrand: 'VISA',
        paymentCard: {
          bin: '5hgg',
          last4Digits: '5665',
          holder: 'ali',
          expiryMonth: '5',
          expiryYear: '9',
          issuerBank: 'banck',
          type: 'VISA'
        },
        modifiedOnUtc: '2025-02-18T20:11:49.4609172',
        createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
        modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
        createdOnUtc: '2025-02-18T20:11:49.4609054'
      },
      projectId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      paymentConfigurationId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      orderId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      paymentType: 'webhookToken',
      status: 'success',
      source: 'SubscriptionB2C',
      amount: {
        amount: 50,
        currency: 'SAR'
      },
      vatAmount: {
        amount: 50,
        currency: 'SAR'
      },
      subTotal: {
        amount: 50,
        currency: 'SAR'
      },
      vatPercentage: 51,
      currency: 'SAR',
      transactionId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      failureReason: 'none',
      logs: [
    {
      id: '2025-02-18T20:11:49.4609172',
      type: 'PaymentRequest',
      transactionResponse: 'response',
      modifiedOnUtc: '2025-02-18T20:11:49.4609172',
      createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      createdOnUtc: '2025-02-18T20:11:49.4609054'
    },
  ],
      modifiedOnUtc: '2025-02-18T20:11:49.4609172',
      createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      createdOnUtc: '2025-02-18T20:11:49.4609054'
    },
    {
      id: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      paymentRequest: {
        id: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
        paymentId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
        paymentConfigurationId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
        paymentProviderType: 'hyperpay',
        paymentRequestId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
        paymentUrl: 'url',
        integrity: 'integrity url',
        modifiedOnUtc: '2025-02-18T20:11:49.4609172',
        createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
        modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
        createdOnUtc: '2025-02-18T20:11:49.4609054'
      },
      onlinePaymentDetail: {
        id: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
        paymentId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
        paymentBrand: 'VISA',
        paymentCard: {
          bin: '5hgg',
          last4Digits: '5665',
          holder: 'ali',
          expiryMonth: '5',
          expiryYear: '9',
          issuerBank: 'banck',
          type: 'VISA'
        },
        modifiedOnUtc: '2025-02-18T20:11:49.4609172',
        createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
        modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
        createdOnUtc: '2025-02-18T20:11:49.4609054'
      },
      projectId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      paymentConfigurationId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      orderId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      paymentType: 'webhookToken',
      status: 'success',
      source: 'SubscriptionB2C',
      amount: {
        amount: 50,
        currency: 'SAR'
      },
      vatAmount: {
        amount: 50,
        currency: 'SAR'
      },
      subTotal: {
        amount: 50,
        currency: 'SAR'
      },
      vatPercentage: 51,
      currency: 'SAR',
      transactionId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      failureReason: 'none',
      logs: [
    {
      id: '2025-02-18T20:11:49.4609172',
      type: 'PaymentRequest',
      transactionResponse: 'response',
      modifiedOnUtc: '2025-02-18T20:11:49.4609172',
      createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      createdOnUtc: '2025-02-18T20:11:49.4609054'
    },
  ],
      modifiedOnUtc: '2025-02-18T20:11:49.4609172',
      createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      createdOnUtc: '2025-02-18T20:11:49.4609054'
    },
    {
      id: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      paymentRequest: {
        id: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
        paymentId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
        paymentConfigurationId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
        paymentProviderType: 'hyperpay',
        paymentRequestId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
        paymentUrl: 'url',
        integrity: 'integrity url',
        modifiedOnUtc: '2025-02-18T20:11:49.4609172',
        createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
        modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
        createdOnUtc: '2025-02-18T20:11:49.4609054'
      },
      onlinePaymentDetail: {
        id: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
        paymentId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
        paymentBrand: 'VISA',
        paymentCard: {
          bin: '5hgg',
          last4Digits: '5665',
          holder: 'ali',
          expiryMonth: '5',
          expiryYear: '9',
          issuerBank: 'banck',
          type: 'VISA'
        },
        modifiedOnUtc: '2025-02-18T20:11:49.4609172',
        createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
        modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
        createdOnUtc: '2025-02-18T20:11:49.4609054'
      },
      projectId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      paymentConfigurationId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      orderId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      paymentType: 'webhookToken',
      status: 'success',
      source: 'SubscriptionB2C',
      amount: {
        amount: 50,
        currency: 'SAR'
      },
      vatAmount: {
        amount: 50,
        currency: 'SAR'
      },
      subTotal: {
        amount: 50,
        currency: 'SAR'
      },
      vatPercentage: 51,
      currency: 'SAR',
      transactionId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      failureReason: 'none',
      logs: [
    {
      id: '2025-02-18T20:11:49.4609172',
      type: 'PaymentRequest',
      transactionResponse: 'response',
      modifiedOnUtc: '2025-02-18T20:11:49.4609172',
      createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      createdOnUtc: '2025-02-18T20:11:49.4609054'
    },
  ],
      modifiedOnUtc: '2025-02-18T20:11:49.4609172',
      createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      createdOnUtc: '2025-02-18T20:11:49.4609054'
    },
    {
      id: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      paymentRequest: {
        id: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
        paymentId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
        paymentConfigurationId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
        paymentProviderType: 'hyperpay',
        paymentRequestId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
        paymentUrl: 'url',
        integrity: 'integrity url',
        modifiedOnUtc: '2025-02-18T20:11:49.4609172',
        createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
        modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
        createdOnUtc: '2025-02-18T20:11:49.4609054'
      },
      onlinePaymentDetail: {
        id: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
        paymentId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
        paymentBrand: 'VISA',
        paymentCard: {
          bin: '5hgg',
          last4Digits: '5665',
          holder: 'ali',
          expiryMonth: '5',
          expiryYear: '9',
          issuerBank: 'banck',
          type: 'VISA'
        },
        modifiedOnUtc: '2025-02-18T20:11:49.4609172',
        createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
        modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
        createdOnUtc: '2025-02-18T20:11:49.4609054'
      },
      projectId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      paymentConfigurationId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      orderId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      paymentType: 'webhookToken',
      status: 'success',
      source: 'SubscriptionB2C',
      amount: {
        amount: 50,
        currency: 'SAR'
      },
      vatAmount: {
        amount: 50,
        currency: 'SAR'
      },
      subTotal: {
        amount: 50,
        currency: 'SAR'
      },
      vatPercentage: 51,
      currency: 'SAR',
      transactionId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      failureReason: 'none',
      logs: [
        {
          id: '2025-02-18T20:11:49.4609172',
          type: 'PaymentRequest',
          transactionResponse: 'response',
          modifiedOnUtc: '2025-02-18T20:11:49.4609172',
          createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
          modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
          createdOnUtc: '2025-02-18T20:11:49.4609054'
        },
      ],
      modifiedOnUtc: '2025-02-18T20:11:49.4609172',
      createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      createdOnUtc: '2025-02-18T20:11:49.4609054'
    }
  ],
  paginationMetadata: {
    totalItemCount: 4,
    numberOfPages: 1,
    pageSize: 10,
    order: 'Ascending',
    page: 1,
    hasNext: false,
    hasPrevious: false
  }
};

const paymentResponse: IPaymentResponse = {
  id: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
  paymentRequest: {
    id: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
    paymentId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
    paymentConfigurationId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
    paymentProviderType: 'hyperpay',
    paymentRequestId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
    paymentUrl: 'url',
    integrity: 'integrity url',
    modifiedOnUtc: '2025-02-18T20:11:49.4609172',
    createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
    modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
    createdOnUtc: '2025-02-18T20:11:49.4609054'
  },
  onlinePaymentDetail: {
    id: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
    paymentId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
    paymentBrand: 'VISA',
    paymentCard: {
      bin: '5hgg',
      last4Digits: '5665',
      holder: 'ali',
      expiryMonth: '5',
      expiryYear: '9',
      issuerBank: 'banck',
      type: 'VISA'
    },
    modifiedOnUtc: '2025-02-18T20:11:49.4609172',
    createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
    modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
    createdOnUtc: '2025-02-18T20:11:49.4609054'
  },
  projectId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
  paymentConfigurationId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
  orderId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
  paymentType: 'webhookToken',
  status: 'success',
  source: 'SubscriptionB2C',
  amount: {
    amount: 50,
    currency: 'SAR'
  },
  vatAmount: {
    amount: 50,
    currency: 'SAR'
  },
  subTotal: {
    amount: 50,
    currency: 'SAR'
  },
  vatPercentage: 51,
  currency: 'SAR',
  transactionId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
  failureReason: 'none',
  logs: [
    {
      id: '2025-02-18T20:11:49.4609172',
      type: 'PaymentRequest',
      transactionResponse: 'response',
      modifiedOnUtc: '2025-02-18T20:11:49.4609172',
      createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      createdOnUtc: '2025-02-18T20:11:49.4609054'
    },
  ],
  modifiedOnUtc: '2025-02-18T20:11:49.4609172',
  createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
  modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
  createdOnUtc: '2025-02-18T20:11:49.4609054'
};

const lookups: IPaymentLookupsResponse = {
  statuses: [
    {
      englishName: 'Pending',
      arabicName: 'قيد الانتظار',
      id: 'Pending'
    },
    {
      englishName: 'Success',
      arabicName: 'ناجحة',
      id: 'Success'
    },
  ],
  sources: [
    {
      englishName: 'SubscriptionB2B',
      arabicName: 'اشتراك من شركة إلى شركة',
      id: 'SubscriptionB2B'
    },
    {
      englishName: 'SubscriptionB2C',
      arabicName: 'اشتراك من شركة إلى مستهلك',
      id: 'SubscriptionB2C'
    }
  ],
  logTypes: [
    {
      englishName: 'PaymentRequest',
      arabicName: 'طلب دفع',
      id: 'PaymentRequest'
    },
    {
      englishName: 'WebHook',
      arabicName: 'وصلة الويب التلقائية',
      id: 'WebHook'
    }
  ],
  onlinePaymentMethods: [
    {
      englishName: 'MADA',
      arabicName: 'مدى',
      id: 'MADA'
    },
    {
      englishName: 'VISA',
      arabicName: 'فيزا',
      id: 'VISA'
    }
  ]
}

export const paymentsData = {
  paymentsResponse: paymentsResponse,
  paymentResponse: paymentResponse,
  lookups: lookups,
};